import {Pipe, PipeTransform} from '@angular/core';

@Pipe({
    name: 'sort'
})
export class SortPipe implements PipeTransform {
    /**
     * Return a sorted list of values
     * @param values
     * @param order
     * @param field
     */
    transform(values: Array<any>, order: string, field?: string): any {
        if (order === 'descending') {
            return values.sort((value, comparator) => {
                return field ? value[field].toString().localeCompare(comparator[field], undefined, {
                    numeric: true,
                    sensitivity: 'base'
                }) : value.toString().localeCompare(comparator, undefined, {numeric: true, sensitivity: 'base'});
            }).reverse();
        } else {
            return values.sort((value, comparator) => {
                return field ? value[field].toString().localeCompare(comparator[field], undefined, {
                    numeric: true,
                    sensitivity: 'base'
                }) : value.toString().localeCompare(comparator, undefined, {numeric: true, sensitivity: 'base'});
            });
        }
    }
}
